// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__-cS19","title":"Images45_title__aVfLM","images":"Images45_images___o6qu"};